module.exports = __webpack_public_path__ + "static/media/index_banner_mobile.9a7a2f1d.png";